'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// ./~/es6-symbol/index.js
// module id = 1
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es6-symbol/index.js